import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment-timezone'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    winners: [],
    winnersByAwardType: {},
    winnersHashById: {},
    winnersIndexById: {},
    winningWorkById: {},
    areas: {},
    // 公式イベント一覧
    talkShows: [],
    // 公式イベント日付一覧
    talkShowsDateList: [],
    // 公式イベント月毎の日付一覧
    talkShowsDateListByMonth: [],
    // 公式イベント一覧(日付キー)
    talkShowsByDate: [],
    // 出展社自主企画イベント
    exhibitorEvents: [],
    specialExhibitions: [],
    specialExhibitionsIndexById: {},
    specialExhibitionById: [],
    tsvLoadCompleteFlag: false,
    // 開催状況
    // なお、開催後に終了するので最終的には isExhibitionOpened も isExhibitionClosed も true となる
    isExhibitionOpened: false, // 開催したらtrue
    isExhibitionClosed: false // 終了したらtrue
  },
  mutations: {
    setWinners (state, value) {
      state.winners = value

      let index = 0
      for (const winner of state.winners) {
        // winnerIdをキーとしたハッシュを作成
        Vue.set(state.winnersHashById, winner.id, winner)

        // winnerIdをキーとした順番を返す
        Vue.set(state.winnersIndexById, winner.id, index)

        // 受賞タイプ別の一覧を作成
        if (!state.winnersByAwardType[winner.awardType]) {
          Vue.set(state.winnersByAwardType, winner.awardType, [])
        }
        state.winnersByAwardType[winner.awardType].push(winner)

        // winningWork.idをキーとしたハッシュを作成
        if (winner.winningWorks) {
          for (const winningWork of winner.winningWorks) {
            Vue.set(state.winningWorkById, winningWork.id, winningWork)
          }
        }
        index++
      }
    },
    updateWinners (state, winner) {
      // winnersの配列を更新
      const index = state.winnersIndexById[winner.id]
      state.winners.splice(index, 1, winner)

      // winnerIdをキーとしたハッシュを更新
      Vue.set(state.winnersHashById, winner.id, winner)

      // winnerIdをキーとした順番を更新
      Vue.set(state.winnersIndexById, winner.id, index)

      // winningWork.idをキーとしたハッシュを更新
      if (winner.winningWorks) {
        for (const winningWork of winner.winningWorks) {
          Vue.set(state.winningWorkById, winningWork.id, winningWork)
        }
      }
    },
    setEventCalendars (state, value) {
        for (const event of value) {
            if (event.eventType == 1) {
                // 主催者公式イベント
                state.talkShows.push(event)
                const date = moment(event.startAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('M月D日')
                const month = moment(event.startAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('M')
                const day = moment(event.startAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('D')
                // 月一覧を作成
                if (!state.talkShowsDateListByMonth[month]) {
                    Vue.set(state.talkShowsDateListByMonth, month, [])
                }
                // 日付一覧を作成
                if (!state.talkShowsByDate[date]) {
                    Vue.set(state.talkShowsByDate, date, [])
                    state.talkShowsDateList.push(date)
                    state.talkShowsDateListByMonth[month].push(day)
                }
                // 日付をキーにしたリストの作成
                state.talkShowsByDate[date].push(event)
            } else {
                // 出店者自主企画イベント
                state.exhibitorEvents.push(event)
            }
        }
    },
    setSpecialExhibitions (state, value) {
      state.specialExhibitions = value.specialExhibitions
      let index = 0
      for (const specialExhibition of state.specialExhibitions) {
        // winnerIdをキーとした順番を返す
        Vue.set(state.specialExhibitionsIndexById, specialExhibition.id, index)
        index++
      }
    },
    setSpecialExhibition (state, value) {
      Vue.set(state.specialExhibitionById, value.specialExhibition.id, value.specialExhibition)
    },
    setTsvCompleteFlag (state, value) {
      state.tsvLoadCompleteFlag = value
    },
    setAreas (state, value) {
      state.areas = value
    },
    setIsExhibitionOpened (state, value) {
      state.isExhibitionOpened = value
    },
    setIsExhibitionClosed (state, value) {
      state.isExhibitionClosed = value
    }
  },
  actions: {
    setWinners (context, value) {
      context.commit('setWinners', value)
    },
    updateWinners (context, value) {
      context.commit('updateWinners', value)
    },
    setEventCalendars (context, value) {
    context.commit('setEventCalendars', value)
    },
    setSpecialExhibitions (context, value) {
      context.commit('setSpecialExhibitions', value)
    },
    setSpecialExhibition (context, value) {
      context.commit('setSpecialExhibition', value)
    },
    setTsvCompleteFlag (context, value) {
      context.commit('setTsvCompleteFlag', value)
    },
    setAreas (context, value) {
      context.commit('setAreas', value)
    },
    setIsExhibitionOpened (context, value) {
      context.commit('setIsExhibitionOpened', value)
    },
    setIsExhibitionClosed (context, value) {
      context.commit('setIsExhibitionClosed', value)
    }
  },
  getters: {
    winners: (state) => {
      return state.winners
    },
    winnersById: (state) => (value) => {
      return state.winnersHashById[value]
    },
    winnersIndexById: (state) => (value) => {
      return state.winnersIndexById[value]
    },
    winnersByAwardType: (state) => (value) => {
      return state.winnersByAwardType[value]
    },
    winningWorkById: (state) => (value) => {
      return state.winningWorkById[value]
    },
    talkShowsDateList: (state) => {
      return state.talkShowsDateList
    },
    talkShowsDateListByMonth: (state) => (value) => {
      return state.talkShowsDateListByMonth[value]
    },
    talkShowsByDate: (state) => (value) => {
      return state.talkShowsByDate[value]
    },
    talkShows: (state) => {
      return state.talkShows
    },
    exhibitorEvents: (state) => {
      return state.exhibitorEvents
    },
    specialExhibitions: (state) => {
      return state.specialExhibitions
    },
    specialExhibitionsIndexById: (state) => (value) => {
      return state.specialExhibitionsIndexById[value]
    },
    specialExhibitionById: (state) => (value) => {
      return state.specialExhibitionById[value]
    },
    tsvLoadCompleteFlag: (state) => {
      return state.tsvLoadCompleteFlag
    },
    areas: (state) => {
      return state.areas
    },
    isExhibitionOpened: (state) => {
      return state.isExhibitionOpened
    },
    isExhibitionClosed: (state) => {
      return state.isExhibitionClosed
    }
  },
  modules: {
  }
})
